module.exports = __webpack_public_path__ + "img/pokemon.299a6c15.png";